import { Box } from '@rbilabs/universal-components';

export const Group = Box;
